import { render, staticRenderFns } from "./PaymentFlowFooter.vue?vue&type=template&id=02851e88&"
import script from "./PaymentFlowFooter.vue?vue&type=script&lang=js&"
export * from "./PaymentFlowFooter.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFlowFooter.vue?vue&type=style&index=0&id=02851e88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports